import React, { ReactNode, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ListingImageGallery from "components/ListingImageGallery/ListingImageGallery";
import MobileFooterSticky from "./MobileFooterSticky";
import { venueService } from "services/venueService";
import { ListingGalleryImage } from "components/ListingImageGallery/utils/types";

const { REACT_APP_DEFAULT_VENUE_ID } = process.env;

const DetailPagetLayout = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const thisPathname = useLocation().pathname;
  const [searchParams] = useSearchParams();
  const modal = searchParams?.get("modal");

  const [images, setImages] = useState<ListingGalleryImage[]>([]);

  const handleCloseModalImageGallery = () => {
    let params = new URLSearchParams(document.location.search);
    params.delete("modal");
    navigate(`${thisPathname}?${params.toString()}`);
  };

  useEffect(() => {
    (async function () {
      const res = await venueService.getVenuePhotoAlbumByVenueId(Number(REACT_APP_DEFAULT_VENUE_ID));

      if (!res) return;

      setImages(
        res?.album?.map((item: any, index: number) => {
          return {
            id: index,
            url: item?.url,
          };
        })
      );
    })();
  }, []);

  return (
    <div className="ListingDetailPage">
      <ListingImageGallery isShowModal={modal === "PHOTO_TOUR_SCROLLABLE"} onClose={handleCloseModalImageGallery} images={images} />
      <div className="container ListingDetailPage__content" style={{ paddingBottom: "10%" }}>
        {children}
      </div>
      <MobileFooterSticky />
    </div>
  );
};

export default DetailPagetLayout;
